import type { RouteRecordRaw } from "vue-router";

export const routes: RouteRecordRaw[] = [
  {
    path: "/taken",
    name: "tasks.index",
    component: () => import("@/modules/tasks/views/CalendarView.vue"),
    meta: {
      requiresAuth: true,
    },
  },
];
